import React, { useState } from "react";
import classes from "./dashboard.module.css";
import { Avatar, Paper, Typography } from "@mui/material";
import dropdown from "../../../assets/images/dropdown.svg";
import MemberCard from "./MemberCard";
import { getInitialName } from "../../../utilities/commonFunctions";
const TeamDetails = ({ setCurrentTeam, index, currectTeam, details }) => {
  const [currectMember, setCurrentMember] = useState([]);
  const handleClick = () => {
    setCurrentTeam(currectTeam === index ? null : index);
  };
  return (
    <Paper className={classes.TeamDetails}>
      <div className={classes.TeamDetailsContainer}>
        <div className={classes.TeamDetailsLeft}>
          {/* <Avatar
            sx={{
              background:
                "linear-gradient(92.49deg, #1273B8 -2.11%, #AA5469 104.85%)",
              width: "44px",
              height: "44px",
            }}
          >
            {getInitialName(details?.team_name).toUpperCase()}
          </Avatar> */}
          <Typography fontWeight={500}>{details?.team_name}</Typography>
        </div>
        <div className={classes.TeamDetailsRight}>
          <div className={classes.TeamDetailsRightImage}>
            {details?.team_members?.length > 0 &&
            details?.team_members[0]?.user_name ? (
              <>
                <Avatar
                  sx={{
                    position: "absolute",
                    bgcolor: `#1273b8`,
                    width: "35px",
                    height: "35px",
                    border: "1px solid white",
                    fontSize: "12px",
                  }}
                >
                  {details?.team_members[0]?.user_name
                    ? getInitialName(
                        details.team_members[0].user_name,
                      )?.toUpperCase()
                    : "TP"}
                </Avatar>
                {details?.team_members[1] ? (
                  <Avatar
                    sx={{
                      bgcolor: `#1273b8`,
                      position: "absolute",
                      width: "35px",
                      height: "35px",
                      border: "1px solid white",
                      fontSize: "12px",
                    }}
                  >
                    {details?.team_members[1]?.user_name
                      ? getInitialName(
                          details.team_members[1].user_name,
                        )?.toUpperCase()
                      : "TP"}
                  </Avatar>
                ) : null}
                {details?.team_members?.length > 2 ? (
                  <Avatar
                    sx={{
                      bgcolor: `#919191`,
                      position: "absolute",
                      width: "35px",
                      height: "35px",
                      border: "1px solid white",
                      fontSize: "12px",
                    }}
                  >
                    {`+${details?.team_members?.length - 2}`}
                  </Avatar>
                ) : null}
              </>
            ) : null}
          </div>
          <img
            src={dropdown}
            alt="drop_ down"
            style={{
              cursor: "pointer",
              transform: `${
                currectTeam === index ? "rotate(180deg)" : "rotate(0deg)"
              }`,
            }}
            onClick={handleClick}
          />
        </div>
      </div>
      {currectTeam === index ? (
        <div className={classes.TeamDetailsBottom}>
          {details?.team_members?.map((item, index) => (
            <MemberCard
              setCurrentMember={setCurrentMember}
              currectMember={currectMember}
              userdetails={item}
              indexVal={index}
            />
          ))}
        </div>
      ) : null}
    </Paper>
  );
};

export default TeamDetails;
